// The server a user is on, for muting or blocking a whole server: none for
// a local user; else the host of the profile (the server matches the
// actor's host, which the handle's domain can differ from), else the
// handle's domain. Mastodon sends no fqn, so this does not use it.
export const userInstance = (user) => {
  if (user.is_local) return null
  try {
    return new URL(user.statusnet_profile_url).host
  } catch {
    return user.screen_name?.split('@')[1] ?? null
  }
}
